import { render, staticRenderFns } from "./StartsJeVerein.vue?vue&type=template&id=c0bc2738&scoped=true&"
import script from "./StartsJeVerein.vue?vue&type=script&lang=js&"
export * from "./StartsJeVerein.vue?vue&type=script&lang=js&"
import style0 from "./StartsJeVerein.vue?vue&type=style&index=0&id=c0bc2738&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0bc2738",
  null
  
)

export default component.exports